export default __webpack_public_path__ + "media/zurb/img/development-process/hulu-a82cdb8903071cd3a0e7071217fe967f.png";